export enum MixpanelEvent {
  MessageCreated = 'Enviou uma mensagem no mural de recados',
  MessageDeleted = 'Deletou uma mensagem no mural de recados',
  ReadReceiptEnabled = 'Marcou a opção de visualização obrigatória no mural de recados',
  ReadReceiptDisabled = 'Desmarcou a opção de visualização obrigatória no mural de recados',
}
